import { TextField, Typography } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

type Props = {
    setDecisionPassword: (pwd: string) => void;
    setExtractionPassword: (pwd: string) => void;
};

export const ClientPassword = ({
    setDecisionPassword,
    setExtractionPassword,
}: Props) => {
    const { t } = useTranslation();

    return (
        <Flex direction="column" sx={{ mt: '10px' }}>
            <Flex direction="row">
                <Flex direction="column" sx={{ pl: '20px' }}>
                    <TextField
                        required
                        placeholder={t('support.clientDetails.adminPassword')}
                        onChange={(event) =>
                            setDecisionPassword(event.target.value)
                        }
                    />
                    <Typography sx={{ ml: '10px', mr: '10px', pt: '5px' }}>
                        {t('support.clientDetails.adminPasswordHelper')}
                    </Typography>
                </Flex>

                <Flex direction="column" sx={{ pl: '20px' }}>
                    <TextField
                        placeholder={t(
                            'support.clientDetails.extractorPassword',
                        )}
                        onChange={(event) =>
                            setExtractionPassword(event.target.value)
                        }
                    />
                    <Typography sx={{ pl: '10px', pt: '5px' }}>
                        {t('support.clientDetails.extractorPassword')}
                    </Typography>
                </Flex>
            </Flex>
            <Typography sx={{ pl: '30px', pt: '5px' }}>
                <ReportProblemIcon sx={{ verticalAlign: 'middle' }} />{' '}
                {t('support.clientDetails.passwordWarning')}
            </Typography>
        </Flex>
    );
};
